// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"577":"a3ffb26a","738":"1c797887","749":"19475abf","937":"961a0482"}[chunkId] + ".chunk.css";
};